<ng-template #monthView let-modal>
	<div class="modal-header">
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<ng-container *ngIf="datepicked">
			<app-day-sales [inputdate]="datepicked"></app-day-sales>
		</ng-container>
	</div>
	<div class="modal-footer"></div>
</ng-template>

<ng-template #trendChips let-trends>
	<div class="stl-trends">
		<span class="stl-chip" *ngFor="let t of trends" [ngClass]="'stl-chip--' + t.dir">
			<i class="fa" *ngIf="t.dir !== 'flat'" [ngClass]="t.dir === 'up' ? 'fa-long-arrow-up' : 'fa-long-arrow-down'"></i>
			{{ t.key }} {{ t.pct | percent:'1.0-0' }}
		</span>
	</div>
</ng-template>

<div class="stl-wrap" [ngStyle]="themeVars" [ngClass]="{'daydrilldown': dayInvoices}">
	<div class="stl-icon-badge">
		<i class="material-icons">bar_chart</i>
	</div>

	<div class="stl-header">
		<div class="stl-title-group">
			<button class="stl-back-btn" *ngIf="['month', 'day'].includes(overLastStatus.viewing)" (click)="overLastBack()" title="Back">
				<i class="material-icons">arrow_back_ios</i>
				<span>Back</span>
			</button>
			<span class="stl-title">
				<ng-container *ngIf="overLastStatus.viewing == 'year'">Sales This/Last</ng-container>
				<ng-container *ngIf="overLastStatus.viewing == 'month'">Sales This/Last for {{overLastStatus.monthname}}</ng-container>
				<ng-container *ngIf="overLastStatus.viewing == 'day' && overLastStatus.fromyear !== overLastStatus.toyear">Sales for {{overLastStatus.monthname}} {{overLastStatus.day}}, {{overLastStatus.fromyear}} - {{overLastStatus.toyear}}</ng-container>
				<ng-container *ngIf="overLastStatus.viewing == 'day' && overLastStatus.fromyear == overLastStatus.toyear">Sales for {{overLastStatus.monthname}} {{overLastStatus.day}}, {{overLastStatus.fromyear}}</ng-container>
			</span>
			<span class="stl-subtitle" *ngIf="viewingInvoice">Viewing # {{viewingInvoice['orderno']}}</span>
		</div>

		<div class="stl-actions">
			<span class="stl-loading-msg" *ngIf="overLastStatus.loading">
				{{ overLastStatus.message }}
				<svg class="spinner" width="24px" height="24px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>
			</span>
			<button class="stl-icon-btn" *ngIf="canEditTargets" (click)="openTargetEditor()" title="Set sales targets">
				<i class="material-icons">flag</i>
			</button>
		</div>
	</div>

	<div class="stl-stats" *ngIf="thisoverlast && !dayInvoices">
		<div class="stl-stat">
			<span class="stl-stat-val">
				{{ thisoverlast.mtd_units | number:'1.0-0' }} / {{ thisoverlast.mtdlast_units | number:'1.0-0' }}
				<span class="stl-pct" [ngClass]="thisoverlast.percent_updown_units < 0 ? 'text-danger' : 'text-success'">
					<i class="fa" [ngClass]="thisoverlast.percent_updown_units > 0 ? 'fa-long-arrow-up' : 'fa-long-arrow-down'"></i>
					{{ thisoverlast.percent_updown_units | percent:'1.0-0' }}
				</span>
			</span>
			<span class="stl-stat-lbl">Units MTD / MTDL</span>
		</div>
		<div class="stl-stat">
			<span class="stl-stat-val">
				{{ thisoverlast.mtd_dollars | currency }} / {{ thisoverlast.mtdlast_dollars | currency }}
				<span class="stl-pct" [ngClass]="thisoverlast.percent_updown_dollars < 0 ? 'text-danger' : 'text-success'">
					<i class="fa" [ngClass]="thisoverlast.percent_updown_dollars > 0 ? 'fa-long-arrow-up' : 'fa-long-arrow-down'"></i>
					{{ thisoverlast.percent_updown_dollars | percent:'1.0-0' }}
				</span>
			</span>
			<span class="stl-stat-lbl">Sales MTD / MTDL</span>
		</div>
		<div class="stl-stat" *ngIf="mtdTarget > 0">
			<span class="stl-stat-val">
				{{ mtdTarget | currency }}
				<span class="stl-pct" [ngClass]="mtdTargetAttainment >= 1 ? 'text-success' : 'text-danger'">
					{{ mtdTargetAttainment | percent:'1.0-0' }}
				</span>
			</span>
			<span class="stl-stat-lbl">Month Target / Attained</span>
		</div>
	</div>

	<div class="ct-chart" *ngIf="!thisoverlast">
		<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
			<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
		</svg>
	</div>

	<div class="stl-chart" *ngIf="chartGroups.length" [ngClass]="dayInvoices == false ? '' : 'none'">
		<svg class="stl-chart-svg" viewBox="0 0 1000 300" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg">
			<g *ngFor="let tick of chartTicks">
				<line x1="70" x2="980" [attr.y1]="tick.y" [attr.y2]="tick.y" class="stl-gridline"></line>
				<text x="62" [attr.y]="tick.y + 4" class="stl-axis-label" text-anchor="end">{{ tick.label }}</text>
			</g>

			<g class="stl-group" *ngFor="let group of chartGroups; let gi = index" (click)="onChartGroupClick(gi)">
				<rect class="stl-group-bg" [attr.x]="group.x0" y="16" [attr.width]="group.w" height="256">
					<title>{{ group.title }}</title>
				</rect>
				<rect *ngFor="let bar of group.bars"
					class="stl-bar"
					[attr.x]="bar.x" [attr.y]="bar.y" [attr.width]="bar.w" [attr.height]="bar.h"
					[attr.fill]="bar.color" rx="3">
					<title>{{ bar.year }} — {{ group.label }}: {{ bar.value | currency }}</title>
				</rect>
				<text *ngIf="group.showLabel" [attr.x]="group.cx" y="294" class="stl-axis-label" text-anchor="middle">{{ group.label }}</text>
			</g>

			<line *ngFor="let seg of chartTargetSegments" [attr.x1]="seg.x1" [attr.x2]="seg.x2" [attr.y1]="seg.y" [attr.y2]="seg.y" class="stl-target-line"></line>
			<polyline *ngIf="chartTargetPoints" [attr.points]="chartTargetPoints" class="stl-target-line stl-target-line--connect"></polyline>
			<circle *ngFor="let m of chartTargetMarkers" [attr.cx]="m.x" [attr.cy]="m.y" r="4" class="stl-target-dot">
				<title>{{ m.label }}</title>
			</circle>
		</svg>
		<div class="stl-legend">
			<span class="stl-legend-item" *ngFor="let s of chartSeries">
				<span class="stl-swatch" [style.background]="s.color"></span>{{ s.year }}
			</span>
			<span class="stl-legend-item" *ngIf="chartTargetSegments.length">
				<span class="stl-swatch stl-swatch--target"></span>Target
			</span>
		</div>
	</div>

	<div class="row p-0 m-0 invoice-drilldown">
		<div class="invoice-fixed p-0 m-0 mat-elevation-z1" *ngIf="displaydetails && dayInvoices">
			<ngx-extended-pdf-viewer id="pdfviewer" *ngIf="displaydetails.display" [base64Src]="displaydetails.display" useBrowserLocale="true" [handTool]="false" [textLayer]="true" [showOpenFileButton]="false" [showPropertiesButton]="false" [showHandToolButton]="true"></ngx-extended-pdf-viewer>
		</div>
		<table class="w-50 table p-0 m-0 i_table w-100" *ngIf="dayInvoices">
			<thead class="sticky-top w-100">
				<th>Order #</th>
				<th>Type</th>
				<th>Customer #</th>
				<th>Name</th>
				<th>Terms</th>
				<th>Date</th>
				<th>Total</th>
			</thead>
			<tbody>
				<ng-container *ngFor="let row of dayInvoices">
					<tr (click)="openDocument(row.orderno, row.type, row.id, null, 'pdf')" [ngClass]="viewingInvoice['id'] == row.id ? 'selected i_row' : 'i_row'">
						<td>{{row.orderno}}</td>
						<td>
							<ng-container *ngIf="row.type == 10">Invoice</ng-container>
							<ng-container *ngIf="row.type == 11">Credit</ng-container>
						</td>
						<td>{{row.debtorno}}</td>
						<td>{{row.brname}}</td>
						<td>{{row.payterms}}</td>
						<td>{{row.orddateformatted}}</td>
						<td>{{row.ovamount | currency}}</td>
						<td></td>
					</tr>
				</ng-container>
			</tbody>
		</table>
	</div>

	<div class="stl-table-wrap table-responsive mt-3" *ngIf="thisoverlast && !dayInvoices">
		<table class="table table-bordered stl-table" *ngFor="let year of thisoverlast.years; let i = index;">
			<tr>
				<ng-container *ngFor="let month of year.sales; let bf = index;">
					<th *ngIf="bf == 0" class="text-center yearpercent">{{ month.year }}</th>
					<th class="text-center yearpercent" [ngClass]="overLastStatus.viewing == 'month' ? 'p-3' : ''">
						{{ month.label }}
						<ng-container *ngIf="monthTrends(month.label, year, i) as trends">
							<ng-container *ngTemplateOutlet="trendChips; context: { $implicit: trends }"></ng-container>
						</ng-container>
					</th>
				</ng-container>
				<th class="text-center">Total</th>
			</tr>
			<tr>
				<td class="text-center">Qty</td>
				<td class="text-center yearpercent" *ngFor="let month of year.qty">
					<button *ngIf="overLastStatus.viewing == 'year'" mat-flat-button (click)="viewHistory(month.monthnumber, month.year)">{{ month.value | number:'1.0-0' }}</button>
					<button *ngIf="overLastStatus.viewing == 'month'" mat-flat-button (click)="getDaySales(month.daynumber, month.year, '')">{{ month.value | number:'1.0-0' }}</button>
				</td>
				<td class="text-center">{{ getQtyTotalYear(year) | number:'1.0-0' }}</td>
			</tr>
			<tr>
				<td class="text-center">Sales</td>
				<td class="text-center yearpercent" [class.stl-neg]="month.value < 0" *ngFor="let month of year.sales">{{ month.value | currency }}</td>
				<td class="text-center" [class.stl-neg]="getSaleTotalYear(year) < 0">{{ getSaleTotalYear(year) | currency }}</td>
			</tr>
			<tr *ngIf="overLastStatus.viewing == 'year' && yearHasTargets(year)">
				<td class="text-center">Target</td>
				<td class="text-center yearpercent stl-target-cell" *ngFor="let month of year.sales">
					<ng-container *ngIf="targetFor(month.year, month.monthnumber) as target; else noTargetStl">
						{{ target | currency }}
						<span class="stl-chip" *ngIf="attainmentFor(month) as attained"
							[ngClass]="attained >= 1 ? 'stl-chip--up' : 'stl-chip--down'">
							{{ attained | percent:'1.0-0' }}
						</span>
					</ng-container>
					<ng-template #noTargetStl><span class="stl-muted">—</span></ng-template>
				</td>
				<td class="text-center stl-target-cell">{{ yearTargetTotal(year) | currency }}</td>
			</tr>
			<tr *ngIf="user && user.user && user.user.viewcost">
				<td class="text-center">Cost</td>
				<td class="text-center" *ngFor="let month of year.cost">{{ month.value | currency }}</td>
				<td class="text-center">{{ getCostTotalYear(year) | currency }}</td>
			</tr>
		</table>
	</div>
</div>
